// 甘孜市场
<template>
  <div class="subpage ganzi" :style="rootVars">
    <div class="flx-bs container">
      <div class="left">
        <div class="part" v-if="active!==4">
          <div class="head"><span class="title"><i class="icon icon-cow"></i>{{ $C('ganzi','headCommonYak','常见的牦牛') }}</span></div>
          <ul class="flx types">
            <li v-for="(item,index) in typeData" :key="index">
              <div class="box">
                <img class="photo" :src="item.photo"/>
                <h3 class="name">{{item.name}}</h3>
              </div>
              <div class="mypopper" :style="index==typeData.length-2 || index==typeData.length-1?{bottom:0,top:'auto'}:''">
                <div class="flx-bc pop_content">
                  <img class="photo" :src="item.photo"/>
                  <div class="info">
                    <h3 class="name">{{item.name}}</h3>
                    <p v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="part park-part" v-if="active===4">
          <div class="head"><span class="title"><i class="icon icon-cow"></i>{{ $C('ganzi','headParkOverview','入园企业2026年产值总览') }}</span></div>
          <!-- 饼图（左）与企业年产值明细（右）并排，彻底避免标签重叠 -->
          <div class="park-body">
            <div class="park-pie-wrap">
              <div class="parkPie" id="parkPie"></div>
            </div>
            <div class="park-data">
              <div class="park-data-head">
                <span class="h-name">{{ $C('ganzi','parkHeadCompany','入园企业') }}</span>
                <span class="h-val">{{ $C('ganzi','parkHeadValue','2026年产值') }}</span>
                <span class="h-pct">{{ $C('ganzi','parkHeadPct','占比') }}</span>
              </div>
              <ul class="park-data-list">
                <li v-for="(c,idx) in displayedParkCompanies" :key="idx" :class="{lead:c.lead}" @click="onCompanyRowClick(c)">
                  <span class="d-dot" :style="{background:c.color}"></span>
                  <span class="d-name">
                    {{c.name}}
                    <a v-if="c.website" class="d-site" :href="c.website" target="_blank" @click.stop>{{ $C('ganzi','siteLabel','🌐 官网 ↗') }}</a>
                  </span>
                  <span class="d-val" v-if="c.value > 0">{{c.value}} {{ $C('ganzi','unitWan','万') }}</span>
                  <span class="d-val" v-else>—</span>
                  <span class="d-pct" v-if="c.value > 0">{{c.pct}}%</span>
                  <span class="d-pct" v-else>—</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="park-desc">
            <p>{{ $C('ganzi','parkDesc','园区形成牦牛加工、数字赋能、电商销售、文旅宣传于一体的完整产业链闭环。') }}</p>
          </div>
          <div class="park-summary">
            <p>{{ $C('ganzi','parkSummary','园区 2026 年总产值 2631 万元：牦牛加工为主（康巴圣德 2165 万、创智环保 266 万），数字科技服务 200 万元。完整产业链持续带动群众增收，支撑炉霍乡村振兴。') }}</p>
          </div>
        </div>
      </div>
      <div class="middle">
        <ul class="flx-cc btns">
          <li class="btn" @click="active=1" :style="$width===6144?{'margin-right':'30px','padding':'0 30px'}:''"><a>{{ $C('ganzi','btnDistance','炉霍工厂与奶渣原料地距离') }}</a></li>
          <li class="btn" @click="active=2" :style="$width===6144?{'margin-right':'30px','padding':'0 30px'}:''"><a>{{ $C('ganzi','btnYakDist','牦牛数量分布') }}</a></li>
          <li class="btn" @click="active=4" :style="$width===6144?{'margin-right':'30px','padding':'0 30px'}:''"><a>{{ $C('ganzi','btnPark','牦牛酪蛋白产业园') }}</a></li>
          <!-- 康巴圣德经营数据入口已移除：现由「酪蛋白产业链数字化 → 销售分析」进入 -->
          <li class="btn" @click="$router.push('/industry-chain')" :style="$width===6144?{'padding':'0 30px'}:''"><a>{{ $C('ganzi','btnChain','酪蛋白产业链数字化') }}</a></li>
        </ul>
        <div v-if="active===1" class="map" id="sichuanMap"></div>
        <div v-if="active===2" class="map" id="interMap"></div>
        <div v-if="active===3" class="map" id="chinaMap"></div>
        <div v-if="active===4" class="map" id="luhuoMap"></div>
      </div>
      <div class="right">
        <div class="part" v-if="active!==4">
          <div v-if="active===1">
            <div class="head"><span class="title"><i class="icon icon-fenbu"></i>{{ $C('ganzi','headDistance','炉霍工厂与奶渣原料地距离') }}</span></div>
            <div class="areaBox" id="distance"></div>
          </div>
          <div v-if="active===2">
            <div class="head"><span class="title"><i class="icon icon-fenbu"></i>{{ $C('ganzi','headYakDist','牦牛数量分布') }}</span></div>
            <div class="areaBox" id="areaInter"></div>
          </div>
          <div v-if="active===3">
            <div class="head"><span class="title"><i class="icon icon-fenbu"></i>{{ $C('ganzi','headChinaYak','中国牦牛数量分布') }}</span></div>
            <div class="areaBox" id="areaChina"></div>
          </div>
          <ul class="flx-lc btns">
            <li class="btn" @click="nutrShow=true"><a>{{ $C('ganzi','btnNutrition','牦牛乳的相关产品及成分') }}</a></li>
            <li class="btn" @click="chartShow=true;"><a>{{ $C('ganzi','btnBuy','购买食物所考虑的因素') }}</a></li>
            <li class="btn" @click="digShow=true;"><a>{{ $C('ganzi','btnStandard','酪蛋白的企业标准及视频') }}</a></li>
            <li class="btn"><a :href="url" target="_blank">{{ $C('ganzi','linkQula','曲拉回收可视化数据实时监控') }}</a></li>
            <!-- 曲拉收购可视化平台入口已移除：现由「酪蛋白产业链数字化 → 原料收购」进入 -->
          </ul>
        </div>
        <!-- 右侧：乡村振兴 + 十五五规划 纵向两板块 -->
        <div class="part right-panel" v-if="active===4">
          <!-- 乡村振兴 -->
          <div class="section section-rural">
            <div class="head">
              <span class="title"><i class="icon icon-fenbu"></i>{{ $C('ganzi','headRural','乡村振兴') }}</span>
            </div>
            <div class="rural-body">
              <!-- 直接带动就业：左侧柱状面积图 + 右侧人均收入进度条 -->
              <div class="rural-row direct">
                <div class="rural-chart-wrap">
                  <div class="sub-title"><i class="dot"></i>{{ $C('ganzi','ruralDirectJobs','直接带动就业') }}</div>
                  <div class="rural-chart" id="ruralJobsChart"></div>
                </div>
                <div class="income-wrap">
                  <div class="sub-title"><i class="dot"></i>{{ $C('ganzi','ruralIncomeTitle','人均收入') }}</div>
                  <ul class="income-list">
                    <li v-for="(item,idx) in ruralIncome" :key="idx">
                      <div class="income-year">{{item.year}}{{ $C('ganzi','unitYear','年') }}</div>
                      <div class="income-bar">
                        <div class="income-track">
                          <div class="income-fill" :style="{width: item.pct+'%'}"></div>
                        </div>
                        <div class="income-value">
                          <span class="arrow">➜</span>{{item.value.toLocaleString()}}<span class="unit">{{ $C('ganzi','unitYuan','元') }}</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div class="income-summary">{{ $C('ganzi','incomeSummaryPre','人均收入：') }}<span class="num">{{ $C('ganzi','incomeSummaryNum','4,152') }}</span>{{ $C('ganzi','incomeSummaryUnit',' 元') }}</div>
                </div>
              </div>
              <!-- 间接带动就业 + 带动合作社 -->
              <div class="rural-row second">
                <div class="rural-block indirect">
                  <div class="sub-title"><i class="dot"></i>{{ $C('ganzi','ruralIndirectJobs','间接带动就业') }}</div>
                  <ul class="indirect-list">
                    <li v-for="(item,idx) in ruralIndirect" :key="idx">
                      <div class="ind-year">{{item.year}}{{ $C('ganzi','unitYear','年') }}</div>
                      <div class="ind-value" :class="{active: item.active}">{{item.value}}<span>{{ $C('ganzi','unitAbove','个以上') }}</span></div>
                    </li>
                  </ul>
                </div>
                <div class="rural-block coop">
                  <div class="sub-title"><i class="dot"></i>{{ $C('ganzi','ruralCoop','带动合作社') }}</div>
                  <div class="coop-list">
                    <div class="coop-card">
                      <div class="coop-name">{{ $C('ganzi','coopName1','炉霍县呷托牦牛养殖农民专业合作社') }}</div>
                      <div class="coop-items">
                        <div class="coop-item">
                          <span class="coop-label">{{ $C('ganzi','coopLabel1','2026年产值（截至7月）') }}</span>
                          <span class="coop-value">{{ $C('ganzi','coopValue1','470.00') }} <small>{{ $C('ganzi','unitWan','万') }}</small></span>
                        </div>
                      </div>
                    </div>
                    <div class="coop-card">
                      <div class="coop-name">{{ $C('ganzi','coopName2','炉霍县霍尔牧兴牦牛养殖农民专业合作社') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 十五五规划 -->
          <div class="section section-plan">
            <div class="head">
              <span class="title"><i class="icon icon-fenbu"></i>{{ $C('ganzi','headPlan15','十五五规划') }}</span>
            </div>
            <div class="plan-layout">
              <!-- 左：总计投入资金（删除环形图，仅保留文字） -->
              <div class="plan-ring">
                <div class="plan-total">
                  <div class="plan-total-label">{{ $C('ganzi','planTotalLabel','总计投入资金') }}</div>
                  <div class="plan-total-value">{{ $C('ganzi','planTotalValue','8000') }} <small>{{ $C('ganzi','unitWan','万') }}</small></div>
                </div>
                <div class="plan-land">
                  <span class="land-label">{{ $C('ganzi','planLandLabel','园区工业用地（自有）') }}</span>
                  <span class="land-value">{{ $C('ganzi','planLandValue','48') }} <small>{{ $C('ganzi','unitMu','亩') }}</small></span>
                </div>
              </div>
              <!-- 右：7 项投资明细清单（编号·项目·金额，清晰对齐） -->
              <ul class="plan-list">
                <li v-for="(c,idx) in plan15Data" :key="idx">
                  <span class="p-no" :style="{background:c.color}">{{c.no}}</span>
                  <span class="p-name">{{c.name}}</span>
                  <span class="p-val">{{c.value.toLocaleString()}} <small>{{ $C('ganzi','unitWan','万') }}</small></span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nutrition v-if="nutrShow" :visible.sync="nutrShow" :title="$C('ganzi','btnNutrition','牦牛乳的相关产品及成分')" :data="nutrition"></Nutrition>
    <Distance v-if="distanceShow" :visible.sync="distanceShow" :title="$C('ganzi','headDistance','炉霍工厂与奶渣原料地距离')" :data="distanceData"></Distance>
    <ChartDig v-if="chartShow" :visible.sync="chartShow" :title="$C('ganzi','btnBuy','购买食物所考虑的因素')" :data="buyData"></ChartDig>
    <MyDialog v-if="digShow" :visible.sync="digShow" :title="$C('ganzi','btnStandard','酪蛋白的企业标准及视频')" :data="dialogData"></MyDialog>

    <!-- 入园企业详情弹层：点击饼图扇区/明细列表打开，按 6家公司设计规划 统一版式 -->
    <div class="company-overlay" v-if="companyDetail" :style="{'--c-color': companyDetail.color}">
      <div class="co-nav">
        <span class="co-nav-title">{{selectedCompany}}</span>
        <button class="co-close" @click="closeCompany">{{ $C('ganzi','coClose','✕ 返回园区') }}</button>
      </div>
      <div class="co-content">
        <section class="co-sec">
          <div class="co-sec-head"><i></i>{{ $C('ganzi','secIntro','公司/协会介绍') }}</div>
          <p class="co-para">{{companyDetail.intro}}</p>
        </section>
        <section class="co-sec">
          <div class="co-sec-head"><i></i>{{ $C('ganzi','secPositioning','品牌定位') }}</div>
          <p class="co-para">{{companyDetail.positioning}}</p>
        </section>
        <section class="co-sec">
          <div class="co-sec-head"><i></i>{{ $C('ganzi','secBiz','核心业务板块') }}</div>
          <div class="co-biz-grid">
            <div class="co-biz" v-for="(b,bi) in companyDetail.businesses" :key="bi">
              <div class="co-biz-no">{{bi+1}}</div>
              <div class="co-biz-body">
                <h3 class="co-biz-title">{{b.title}}</h3>
                <p class="co-biz-desc">{{b.desc}}</p>
              </div>
            </div>
          </div>
            <div class="co-chart-wrap">
              <div class="co-chart-title">{{ $C('ganzi','coChartTitle','核心量化数据') }}</div>
            <div id="companyBar" class="company-bar"></div>
          </div>
        </section>
        <section class="co-sec">
          <div class="co-sec-head"><i></i>{{ $C('ganzi','secProjects','落地项目清单') }}</div>
          <div class="co-biz-grid">
            <div class="co-biz" v-for="(p,pi) in companyDetail.projects" :key="pi">
              <div class="co-biz-no">{{pi+1}}</div>
              <div class="co-biz-body">
                <h3 class="co-biz-title">{{p.title}}</h3>
                <p class="co-biz-desc">{{p.desc}}</p>
              </div>
            </div>
          </div>
        </section>
        <section class="co-sec">
          <div class="co-sec-head"><i></i>{{ $C('ganzi','secAdv','核心竞争优势') }}</div>
          <ul class="co-adv">
            <li v-for="(a,ai) in companyDetail.advantages" :key="ai">{{a}}</li>
          </ul>
        </section>
        <section class="co-sec">
          <div class="co-sec-head"><i></i>{{ $C('ganzi','secPlan','发展规划') }}</div>
          <div class="co-plan">
            <div class="co-plan-col">
              <div class="co-plan-tag short">{{ $C('ganzi','planShort','短期规划（1-2年）') }}</div>
              <p class="co-para">{{companyDetail.plans.short}}</p>
            </div>
            <div class="co-plan-col">
              <div class="co-plan-tag mid">{{ $C('ganzi','planMid','中期规划（3-5年）') }}</div>
              <p class="co-para">{{companyDetail.plans.mid}}</p>
            </div>
            <div class="co-plan-col">
              <div class="co-plan-tag long">{{ $C('ganzi','planLong','长期规划（5年以上）') }}</div>
              <p class="co-para">{{companyDetail.plans.long}}</p>
            </div>
          </div>
        </section>
      </div>
      <div class="co-footer">{{ $C('ganzi','companyFooter','甘孜州牦牛酪蛋白产业园 · 入园企业展示 · 数据来源：6家公司设计规划') }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import echarts from 'echarts'
import 'echarts/map/js/china'
import Nutrition from './nutrition';
import Distance from './distance';
import MyDialog from './dialog.vue';
import ChartDig from './chart.vue'
import companyInfo from './companyInfo'
import 'echarts/map/js/world'
import 'echarts/map/js/province/sichuan'
// 地图翻译文件
import { nameMap } from '../../../public/assets/geo/nameMap'
import { mediaUrl } from '@/cms/config'

// 以下为硬编码在页内的数据「当前值」，作为 $CList 的本地兜底默认值（后台未配置时渲染一致）。
// 后台「甘孜市场 → 数据指标」可直接维护，未配置时沿用下列内置值。
const PARK_COMPANIES = [
  { name: '康巴圣德牦牛产业有限公司', value: 2165, pct: '82.3', color: '#FFD942', lead: true, website: 'https://www.casein-industry.com/' },
  { name: '甘孜州川妤生物科技有限公司', value: 0, pct: '0.0', color: '#42AAFF' },
  { name: '甘孜州康创未来数字科技有限公司', value: 200, pct: '7.6', color: '#0CFBFF' },
  { name: '甘孜州雪域三千传媒有限公司', value: 0, pct: '0.0', color: '#5B8FF9' },
  { name: '甘孜州章谷臻品电子商务有限公司', value: 0, pct: '0.0', color: '#3CB0FF' },
  { name: '炉霍创智环保设备制造有限公司', value: 266, pct: '10.1', color: '#2A54A2' },
  { name: '炉霍县互联网文化旅游推广协会', value: 0, pct: '0.0', color: '#8B5CF6' },
]
const RURAL_JOBS = [
  { year: '2023', value: 22 },
  { year: '2024', value: 25 },
  { year: '2025', value: 26 },
]
const RURAL_INCOME = [
  { year: '2023', value: 3900, pct: 93.8 },
  { year: '2024', value: 4160, pct: 100 },
  { year: '2025', value: 4152, pct: 99.8 },
]
const RURAL_INDIRECT = [
  { year: '2023', value: '100', active: false },
  { year: '2024', value: '200', active: true },
  { year: '2025', value: '200', active: true },
]
const PLAN15_DATA = [
  { name: '户外直播和园区文旅基地打造', value: 200, no: '01', color: '#00F0FF' },
  { name: '园区道路及形象优化', value: 100, no: '02', color: '#00D8E8' },
  { name: '酪蛋白生产线固定资产', value: 3000, no: '03', color: '#00C0D1' },
  { name: '园区配套锅炉及环保设施', value: 500, no: '04', color: '#00A8BA' },
  { name: '原料渠道建设', value: 200, no: '05', color: '#0090A3' },
  { name: '原料收购铺底流动资金', value: 1800, no: '06', color: '#00788C' },
  { name: '新建博士工作站', value: 300, no: '07', color: '#006070' },
  { name: '新生产线及园区数字化改造', value: 1900, no: '08', color: '#004858' },
]
export default {
  name: '',
  components: { Nutrition,Distance,MyDialog,ChartDig },
  data() {
    return {
      typeData: [],
      interData: [],
      chinaData: [],
      nutrition: {},
      nutrShow: false,
      distanceData: {},
      distanceShow: false,
      url: '',
      active: 1, //地图中间显示内容，默认为四川
      buyData: {},
      dialogData: {},
      digShow: false, //定制弹窗
      chartShow: false,
      chartData: {},
      // 入园企业详情弹层：当前选中的公司 key（对应 companyInfo 的键），null 表示关闭
      selectedCompany: null,
      companyChart: null,
      parkOverview: {
        output: '约 2.85 亿元（示例）',
        gdp: '约 2.10 亿元（示例）',
        fixedAsset: '约 5.60 亿元（示例）',
        directJobs: '约 1200 人，人均收入约 6.5 万元/年（示例）',
        indirectJobs: '约 8500 户，人均增收约 1.2 万元/年（示例）',
        plan15: '建设国家级牦牛酪蛋白产业集群，产值突破 10 亿元，带动就业 5000 人以上（示例占位）',
      },
      plan15Land: '48',
    };
  },
  computed: {
    // 当前弹层展示的公司详情（无选中时为 null）
    companyDetail() {
      if (!this.selectedCompany) return null
      return companyInfo[this.selectedCompany] || null
    },
    // 后台可配置的页面背景图（覆盖默认系统底图），未配置时不影响现有外观
    rootVars() {
      const bg = this.$C('ganzi', 'pageBg', '')
      return bg ? {
        backgroundImage: `url("${mediaUrl(bg)}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      } : {}
    },
    // 以下数组接入 CMS：后台「甘孜市场 → 数据指标」可直接维护，未配置时沿用内置默认
    parkCompanies() { return this.$CList('ganzi', 'parkCompanies', PARK_COMPANIES) },
    ruralJobs() { return this.$CList('ganzi', 'ruralJobs', RURAL_JOBS) },
    ruralIncome() { return this.$CList('ganzi', 'ruralIncome', RURAL_INCOME) },
    ruralIndirect() { return this.$CList('ganzi', 'ruralIndirect', RURAL_INDIRECT) },
    plan15Data() { return this.$CList('ganzi', 'plan15Data', PLAN15_DATA) },
    // 入园企业：全部显示（0 万企业不隐藏），仅不渲染其金额文字；按金额从多到少排序
    displayedParkCompanies() {
      return this.parkCompanies
        .slice()
        .sort(function (a, b) { return b.value - a.value })
    }
  },
  created() {
    // 顶部"返回"在甘孜市场内部 tab（如牦牛酪蛋白产业园）时，先回到甘孜市场默认视图再回首页
    this.$root.$off('ganzi-layout-back', this.onLayoutBack)
    this.$root.$on('ganzi-layout-back', this.onLayoutBack)
  },
  beforeDestroy() {
    this.$root.$off('ganzi-layout-back', this.onLayoutBack)
  },
  mounted() {
  },
  watch: {
    '$route.path':{
      handler(path){
        if(path==='/ganzi'){
          // this.fetchData('/assets/ganzi.json')
          this.getData('ganzi')
        }
      },
      immediate: true
    },
    active: {
      handler(val){
        if(val===1){
          this.$nextTick(() => {
            this.echartsDistance()
            this.areaEchart()
          })
        }else if(val===2){
          this.$nextTick(() => {
            this.echartsMap(val)
            this.areaEchart()
          })
        }else if(val===3){
          this.$nextTick(() => {
            this.echartsMap(val)
            this.pieEchart()
          })
        }else if(val===4){
          this.$nextTick(() => {
            this.echartsLuhuo()
            this.echartsParkPie()
            this.echartsRuralJobs()
          })
        }
      }
    }
  },
  methods: {
    // 顶部"返回"在甘孜市场内部：先回默认视图（常见的牦牛），再点才回首页
    onLayoutBack() {
      if (this.active !== 1) {
        this.active = 1
        this.$nextTick(() => {
          this.echartsDistance()
          this.areaEchart()
        })
      } else {
        this.$router.push('/index')
      }
    },
    getData(name){
      let params = {fileName: name}
      axios.post(this.$baseUrl+'/api/web/file/data/query',params).then(res => {
        if(res.data.code === 200){
          const jsonData = res.data.data
          this.typeData = jsonData.typeData
          this.interData = jsonData.interData
          this.chinaData = jsonData.chinaData
          this.nutrition = jsonData.nutrition
          this.distanceData = jsonData.distance
          this.buyData = jsonData.buy
          this.url = jsonData.h5url
          this.dialogData = jsonData.dialog
          this.$nextTick(() => {
            this.areaEchart()
            this.echartsDistance()
          })
        }
      })
    },
    fetchData(path) {
      axios.get(path+'?t=' + Date.now()).then(res => {
        const jsonData = res.data
        this.typeData = jsonData.typeData
        this.interData = jsonData.interData
        this.chinaData = jsonData.chinaData
        this.nutrition = jsonData.nutrition
        this.distanceData = jsonData.distance
        this.buyData = jsonData.buy
        this.url = jsonData.h5url
        this.dialogData = jsonData.dialog
        this.$nextTick(() => {
          this.areaEchart()
          this.echartsDistance()
        })
      })
    },
    echartsMap(type){
      var that = this
      var map = null
      let data = []
      if(type===2){
        map = echarts.init(document.getElementById('interMap'));
        data = that.interData
      }else{
        map = echarts.init(document.getElementById('chinaMap'));
        data = that.chinaData
      }
      // 清空图表
      map.clear();
      // 设置地图配置
      var option = {
        title: {
          text: type==2?'':'中国牦牛都生活在哪里？',
          left: 'center',
          top: 90,
          textStyle: {
            color: '#ffffff',
            fontSize: 60,
            fontWeight: 'bold'
          },
        },
        grid: {
          left: 0,   // 左侧距离
          right: 0,  // 右侧距离
          top: 0,   // 可选：顶部距离
          bottom: 0, // 可选：底部距离
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 15,
          textStyle: {
            color: '#ffffff',
            fontSize: 36
          },
          formatter(params) {
            const data = params.data;
            if (!data) {
                return ``
            }
            if(type===2){
              const isCn = params.name === '中国' || params.name === 'China';
              const tip = isCn ? `<p style='margin-top:12px;color:#FFD942;font-weight:700;'>→ 点击进入 · 中国牦牛数量分布</p>` : '';
              return  `
              <div style='padding:26px 48px 28px 44px;font-size:36px;line-height:60px;'>
                <span style='font-size:42px;font-weight:600;margin-right:22px;'>${params.name}</span>
                <span>${data.value2}</span>
                <p>${data.intro}</p>${tip}
              </div>`
            }else{
              return  `
              <div style='padding:26px 48px 28px 44px;font-size:36px;line-height:60px;'>
                <span style='font-size:42px;font-weight:600;margin-right:22px;'>${params.name}</span>
                <span>${data.value}万头</span>
                <p>占比：${data.percent}</p>
              </div>`
            }
          },
        },
         geo: [
            //第一层投影
            {
                left: 15,
                top: 15,
                width: '100%',
                height: '100%',
                map: type===2?'world':'china',
                zlevel: -1,
                roam: false, // 鼠标缩放+平移
                show: true,
                selectedMode: false,
                silent: true, // 禁用鼠标交互
                label: {
                    normal: {
                        show: false
                    },
                    emphasis: {
                        show: false
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor: "#0345A1",
                        shadowOffsetX: 0,
                        shadowOffsetY: 0,
                        // shadowBlur: 10
                    },
                    emphasis: {
                        show: false
                    }
                },
                emphasis:{
                    show:false
                },
                tooltip:{
                    show:false
                }
            }
        ],
        series: [
          {
            // 上层地图
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            name: type===2?'世界地图':'中国地图',
            type: 'map',
            map: type===2?'world':'china',
            roam: false,
            cursor: type===2?'pointer':'default',
            itemStyle: {
              areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                {offset: 0, color: '#387FE9'},
                {offset: 1, color: '#225FBA'}
              ]),
              borderWidth: 3,
              borderColor: '#42AAFF',
            },
            emphasis: {
              itemStyle: {
                  areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                    {offset: 0, color: '#F9B841'},
                    {offset: 1, color: '#FF6524'}
                  ]),
                  borderWidth: 3,
                  borderColor: '#FFD942',
              }
            },
            label: {
              normal: {
                show: type===2?false:true,
                color: '#ffffff',
                fontSize: 36
              },
              emphasis: {
                color: '#ffffff',
                fontSize: 36
              },
            },
            nameMap: nameMap,
            data: (function() {
              let modifiedData = [];
              if(type === 2) { // 世界地图时
                data.forEach(item => {
                  if(item.name === '中国') {
                    modifiedData.push({
                      ...item,
                      itemStyle: {
                        areaColor: '#FF0000', // 红色填充
                        borderColor: '#42AAFF',
                        borderWidth: 3
                      },
                      label: {
                        show: true,
                        color: '#FFFFFF',
                        fontSize: 40,
                        fontWeight: 'bold',
                        formatter: '中国'
                      }
                    });
                  }else {
                    modifiedData.push({
                      ...item,
                      itemStyle: {
                        areaColor: '#ff7a00', // 橙色填充
                        borderColor: '#42AAFF',
                        borderWidth: 3
                      }
                    });
                  }
                });
              } else { // 中国地图时
                data.forEach(item => {
                  if(item.name === '青海') {
                    modifiedData.push({
                      ...item,
                      itemStyle: {
                        areaColor: '#FF0000', // 红色填充
                        borderColor: '#42AAFF',
                        borderWidth: 3
                      }
                    });
                  }else if(item.name === '西藏') {
                    modifiedData.push({
                      ...item,
                      itemStyle: {
                        areaColor: '#ff7a00', // 橙色填充
                        borderColor: '#42AAFF',
                        borderWidth: 3
                      }
                    });
                  }else if(item.name === '四川') {
                    modifiedData.push({
                      ...item,
                      itemStyle: {
                        areaColor: '#00AB6E', // 绿色填充
                        borderColor: '#42AAFF',
                        borderWidth: 3
                      }
                    });
                  }else {
                    modifiedData.push(item);
                  }
                });
              }
              return modifiedData;
            })(),
          }
        ],
      }
      // 设置配置项
      map.setOption(option);

      // 全球牦牛数量分布（世界地图）中点击「中国」→ 进入中国牦牛数量分布
      map.off('click');
      map.on('click', function (params) {
        if (type === 2) {
          var n = params.name;
          if (n === '中国' || n === 'China') {
            that.active = 3; // 切换到「中国牦牛数量分布」(active=3)
          }
        }
      });
    },
    // 与原料地距离
    echartsDistance(){
        var that = this
        // 散点图数据
        if(typeof(this.distanceData.from.value) === 'string'){
            this.distanceData.from.value = this.distanceData.from.value.split(",")
            this.distanceData.to.forEach(it => {it.value = it.value.split(",")})
        }
        var data =  [...this.distanceData.to,this.distanceData.from]
        var LineData = []
        this.distanceData.to.forEach(it => {
            LineData.push({
                fromName: this.distanceData.from.name,
                toName: it.name,
                coords: [this.distanceData.from.value, it.value],
                value: it.value
            })
        })

        var map = echarts.init(document.getElementById('sichuanMap'));
        let option = {
            grid: {
                left: 0,   // 左侧距离
                right: 0,  // 右侧距离
                top: 0,   // 可选：顶部距离
                bottom: 0, // 可选：底部距离
            },
            //地图
            geo: {
                type: 'map',
                map: 'china',
                width: '100%',
                height: '100%',
                top: 0,
                roam: true,
                label: {
                    normal: {
                        show: true,
                        color: '#ffffff',
                        fontSize: 36
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            color: '#ffffff',
                            fontSize: 36
                        },
                    },
                },
                itemStyle: {
                    normal: {
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#387FE9'},
                            {offset: 1, color: '#225FBA'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#42AAFF',
                    },
                    emphasis: {
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#F9B841'},
                            {offset: 1, color: '#FF6524'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#FFD942',
                    },
                },
                // ========== 关键：使用 regions 高亮特定区域 ==========
                regions: (function() {
                    return [{
                      name: '四川',
                      itemStyle: {
                        areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0,[
                            {offset: 0, color: '#F9B841'},
                            {offset: 1, color: '#FF6524'}
                        ]),
                        borderWidth: 3,
                        borderColor: '#FFD942',
                      }
                    }];
                })()
                // ===================================================
            },
            series: [
                // 区域散点图
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    symbolSize: 20,
                    rippleEffect: { //坐标点动画
                        period: 3,
                        scale: 5,
                        brushType: 'fill'
                    },
                    itemStyle: { //坐标点颜色
                        normal: {
                            show: true,
                            color: '#31FFFF',
                            shadowBlur: 20,
                            shadowColor: '#fff'
                        },
                        emphasis: {
                            areaColor: '#f00'
                        }
                    },
                    label: {
                        show: true,
                        position: 'top',
                        color: '#fff',
                        fontSize: 36,
                        formatter: function (params) {
                            return params.name;
                        }
                    },
                    data: data
                },
                //飞线图
                {
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                        show: true,
                        //飞机的速度  这里是s单位
                        period: 6,
                        trailLength: 0,
                        symbol: 'circle',//这是圆点替换了飞机
                        // 飞机大小
                        symbolSize: 20,
                        color:'#31FFFF',
                    },
                    lineStyle: {
                        normal: {
                            color:'#fff',
                            type:'solid', // 虚线
                            // 线条宽度
                            width: 3,
                            opacity: 1,
                            curveness: 0.2, // 弯曲度
                        },
                        emphasis: {
                            color: '#FF9600' //飞线悬浮颜色
                        }
                    },
                    label: {
                        normal: {
                            show: false,
                            position: 'middle',
                            formatter: '{b}'
                        }
                    },
                    data: LineData
                }
            
            ],
        };
        // 设置配置项
        map.setOption(option);
    },
    areaEchart() {
        var that = this;
        var chart = null;
        let source = [];

        if (this.active === 1) {
            chart = echarts.init(document.getElementById('distance'));
            this.distanceData.to.forEach(it => {
                source.push([it.distance, it.name]);
            });
        } else if (this.active === 2) {
            chart = echarts.init(document.getElementById('areaInter'));
            this.interData.forEach(it => {
                source.push([it.value, it.name, it.value2]);
            });
        } else {
            chart = echarts.init(document.getElementById('areaChina'));
            this.chinaData.forEach(it => {
                source.push([it.value, it.name]);
            });
        }

        source.unshift(['amount', 'area']);
        chart.clear();

        var option = {
            dataset: { source: source },
            grid: { left: 77, right: 121, top: 150, bottom: 80, containLabel: true },
            tooltip: {
                trigger: 'axis',
                axisPointer: { type: 'shadow' },
                textStyle: { color: '#fff', fontSize: 36 },
                formatter: function (params) {
                  let data = params[0]
                  return that.active===2?data.name+'：'+data.data[2]:data.name+'：'+data.data[0];
                }
            },
            xAxis: {
                type: that.active===1?'value':'log',
                logBase: 10,
                scale: true,           // ✅ 关键：让轴范围紧贴数据
                min: that.active===1?0:'dataMin',        // ✅ 关键：最小值 = 数据中的最小值（如 0.5）
                max: 'dataMax',        // ✅ 可选：最大值 = 数据中的最大值
                axisLine: { lineStyle: { color: '#2A54A2', width: 3 } },
                axisTick: { show: false },
                splitLine: { show: false },
                axisLabel: {
                    color: '#fff',
                    fontSize: 36,
                    margin: 32,
                    formatter: (val) => val // 显示原始值
                }
            },
            yAxis: {
                type: 'category',
                axisLine: { lineStyle: { color: '#2A54A2', width: 3 } },
                axisTick: { show: false },
                splitLine: {
                    lineStyle: { color: '#2A54A2', type: 'dashed', width: 2 }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: 36,
                    margin: 42
                },
                name: that.active === 1 ? '单位：公里' : '单位：万头',
                nameLocation: 'end',
                nameGap: 60,
                nameRotate: 0,
                nameTextStyle: {
                    color: 'rgba(255,255,255,0.6)',
                    fontSize: 32
                }
            },
            series: [
                {
                    type: 'bar',
                    barWidth: 30,
                    encode: { x: 'amount', y: 'area' },
                    itemStyle: {
                        color: function(params) {
                            const value = params.value[0];
                            if (that.active === 1) {
                                return value > 1000 ? '#00AB6E' : value > 500 ? '#0081C4' : '#DA6300';
                            } else if (that.active === 2) {
                                return value >= 201 ? '#FF0000' : value >= 50 ? '#ff7a00' : '#DA6300';
                            }
                        }
                    }
                }
            ]
        };

        chart.setOption(option);
    },
    pieEchart(){
                let that = this
                var chart = echarts.init(document.getElementById('areaChina'));
                // 清空图表
                chart.clear();
                var option = {
                    // 设置绘图区域的边距
                    grid: {
                        left: '20%',   // 左侧距离
                        right: '20%',  // 右侧距离
                        top: '20%',   // 可选：顶部距离
                        bottom: 0, // 可选：底部距离
                        containLabel: true // 确保标签不被裁剪
                    },
                    
                    series: [
                        {
                            type: 'pie',
                            avoidLabelOverlap: true,
                            label: {
                                show: true,
                                position: 'outside',
                                fontSize: 36,
                                fontWeight: 'bold',
                                color: '#fff',
                                formatter: '{b}\n{c}万头'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 42,
                                    fontWeight: 'bold',
                                    color: '#fff',
                                }
                            },
                            labelLine: {
                                show: true,
                            },
                            data: that.chinaData,
                            color: ['#FF0000','#ff7a00','#00AB6E','#0A5AAE','#0C85FF','#42C8FA'],
                        }
                    ]
                };

                // 使用刚指定的配置项和数据显示图表。
                chart.setOption(option);
            },
    // 牦牛酪蛋白集群产业园：炉霍县地图
    echartsLuhuo(){
      var that = this
      var map = echarts.init(document.getElementById('luhuoMap'));
      map.clear();
      var option = {
        title: {
          text: '炉霍县 · 酪蛋白产业园',
          left: 'center',
          top: 40,
          textStyle: {
            color: '#ffffff',
            fontSize: 56,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 15,
          textStyle: { color: '#ffffff', fontSize: 36 },
          formatter: function (params) {
            if (params.seriesType === 'effectScatter') {
              return '<div style="padding:20px 30px;font-size:36px;">' + params.name + '</div>';
            }
            return '';
          }
        },
        geo: {
          map: '四川',
          roam: false,
          zoom: 1.1,
          label: {
            normal: { show: false },
            emphasis: { show: true, color: '#ffffff', fontSize: 30 }
          },
          itemStyle: {
            normal: {
              areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#387FE9' },
                { offset: 1, color: '#225FBA' }
              ]),
              borderWidth: 3,
              borderColor: '#42AAFF'
            },
            emphasis: {
              areaColor: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#F9B841' },
                { offset: 1, color: '#FF6524' }
              ]),
              borderWidth: 3,
              borderColor: '#FFD942'
            }
          },
          // 高亮甘孜州，标示产业园所在区域
          regions: [
            {
              name: '甘孜藏族自治州',
              itemStyle: {
                areaColor: '#FF0000',
                borderColor: '#FFD942',
                borderWidth: 3
              },
              label: {
                show: true,
                color: '#ffffff',
                fontSize: 30
              }
            },
            {
              name: '成都市',
              itemStyle: {
                areaColor: '#FF7A00',
                borderColor: '#FFD942',
                borderWidth: 3
              },
              label: {
                show: true,
                color: '#ffffff',
                fontSize: 30
              }
            }
          ]
        },
        series: [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            symbolSize: 34,
            rippleEffect: { period: 4, scale: 6, brushType: 'fill' },
            itemStyle: {
              color: '#31FFFF',
              shadowBlur: 20,
              shadowColor: '#ffffff'
            },
            label: {
              show: true,
              position: 'right',
              color: '#ffffff',
              fontSize: 38,
              fontWeight: 'bold',
              formatter: function (params) {
                return params.name
              }
            },
            data: [
              { name: '炉霍县酪蛋白产业园', value: [100.60, 31.39] },
              { name: '科创岛研发中心', value: [104.07, 30.43] }
            ]
          }
        ]
      };
      map.setOption(option);
    },
    // 入园企业2026年产值环形饼图（园区2026年总产值 2631 万）
    echartsParkPie(){
      var that = this
      var el = document.getElementById('parkPie')
      if(!el) return
      var chart = echarts.getInstanceByDom(el)
      if(chart){ echarts.dispose(el) }
      chart = echarts.init(el)
      // 饼图只展示有产值的扇区（0 万企业不占扇区）
      var data = that.displayedParkCompanies
        .filter(function(c){ return c.value > 0 })
        .map(function(c){
          return {
            name: c.name,
            value: c.value,
            itemStyle: { color: c.color },
            selected: !!c.lead
          }
        })
      var option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 15,
          textStyle: { color: '#ffffff', fontSize: 42 },
          formatter: function(p){
            return '<div style="padding:18px 28px;font-size:42px;line-height:60px;">' +
              '<b>' + p.name + '</b><br/>2026年产值：' + p.value + ' 万元<br/>占比：' + p.percent + '%</div>'
          }
        },
        // 中心标注园区总产值
        graphic: [{
          type: 'text',
          left: 'center',
          top: '42%',
          style: {
            text: '园区2026年总产值\n2631 万',
            textAlign: 'center',
            fill: '#ffffff',
            fontSize: 50,
            fontWeight: 'bold',
            lineHeight: 64
          }
        }],
        series: [{
          name: '年产值',
          type: 'pie',
          radius: ['46%', '72%'],
          center: ['50%', '50%'],
          selectedMode: 'single',
          selectedOffset: 18,
          avoidLabelOverlap: true,
          itemStyle: {
            borderColor: '#061938',
            borderWidth: 3,
            shadowBlur: 12,
            shadowColor: 'rgba(0,0,0,0.45)'
          },
          label: { show: false },
          labelLine: { show: false },
          emphasis: {
            scale: true,
            scaleSize: 12,
            itemStyle: { shadowBlur: 26, shadowColor: 'rgba(255,217,66,0.7)' }
          },
          data: data
        }]
      }
      chart.setOption(option)
      // 点击扇区：康巴圣德(有 website)跳官网；6 家文档主体打开详情弹层
      chart.on('click', function(p){
        var item = that.displayedParkCompanies.find(function(c){ return c.name === p.name })
        if(item && item.website){ window.open(item.website, '_blank'); return }
        if(item && companyInfo[item.name]){ that.openCompany(item.name) }
      })
      window.addEventListener('resize', function(){ chart.resize() })
    },
    // 入园企业详情弹层：点击明细列表行
    onCompanyRowClick(c){
      if(c.website){ window.open(c.website, '_blank'); return }
      if(companyInfo[c.name]){ this.openCompany(c.name) }
    },
    // 打开某家公司详情弹层
    openCompany(name){
      this.closeCompanyChart()
      this.selectedCompany = name
      this.$nextTick(() => { this.echartsCompanyChart() })
    },
    // 关闭弹层并销毁柱状图实例
    closeCompany(){
      this.selectedCompany = null
      this.closeCompanyChart()
    },
    closeCompanyChart(){
      if(this.companyChart){ this.companyChart.dispose(); this.companyChart = null }
    },
    // 弹层内核心量化数据柱状图（4 项指标，label 含单位）
    echartsCompanyChart(){
      var that = this
      var el = document.getElementById('companyBar')
      if(!el) return
      this.closeCompanyChart()
      var chart = echarts.init(el)
      this.companyChart = chart
      var info = this.companyDetail
      if(!info) return
      var data = info.chartData
      var option = {
        grid: { left: 280, right: 120, top: 30, bottom: 30, containLabel: false },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(0,0,0,0.6)', textStyle: { color: '#fff', fontSize: 36 } },
        xAxis: { type: 'value', axisLabel: { color: 'rgba(255,255,255,.75)', fontSize: 30 }, splitLine: { lineStyle: { color: 'rgba(255,255,255,.08)' } } },
        yAxis: {
          type: 'category',
          inverse: true,
          data: data.map(function(d){ return d.label }),
          axisLine: { lineStyle: { color: 'rgba(255,255,255,.25)' } },
          axisTick: { show: false },
          axisLabel: { color: '#fff', fontSize: 34, fontWeight: 600 }
        },
        series: [{
          type: 'bar',
          barWidth: 46,
          data: data.map(function(d){ return d.value }),
          itemStyle: { color: info.color, borderRadius: [0, 12, 12, 0] },
          label: {
            show: true,
            position: 'right',
            color: '#fff',
            fontSize: 34,
            fontWeight: 600,
            formatter: function(p){ return p.value + ' ' + data[p.dataIndex].unit }
          }
        }]
      }
      chart.setOption(option)
      window.addEventListener('resize', function(){ chart.resize() })
    },
    // 乡村振兴 · 直接带动就业岗位：柱状面积图（2023-2025）
    echartsRuralJobs(){
      var that = this
      var el = document.getElementById('ruralJobsChart')
      if(!el) return
      var chart = echarts.getInstanceByDom(el)
      if(chart){ echarts.dispose(el) }
      chart = echarts.init(el)
      var years = that.ruralJobs.map(function(item){ return item.year + '年' })
      var values = that.ruralJobs.map(function(item){ return item.value })
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 12,
          textStyle: { color: '#ffffff', fontSize: 38 },
          formatter: function(p){
            return '<div style="padding:14px 22px;font-size:34px;">' +
              p[0].name + ' 岗位数量：<span style="color:#31FFFF;font-weight:700;">' + p[0].value + ' 个</span>' +
              '</div>'
          }
        },
        grid: { top: 60, right: 30, bottom: 50, left: 60 },
        legend: {
          data: ['岗位数量'],
          top: 10,
          right: 10,
          textStyle: { color: 'rgba(255,255,255,.8)', fontSize: 34 },
          itemWidth: 30,
          itemHeight: 14
        },
        xAxis: {
          type: 'category',
          data: years,
          axisLine: { lineStyle: { color: 'rgba(255,255,255,.3)' } },
          axisLabel: { color: 'rgba(255,255,255,.85)', fontSize: 36 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          max: 30,
          splitLine: { lineStyle: { color: 'rgba(255,255,255,.12)', type: 'dashed' } },
          axisLabel: { color: 'rgba(255,255,255,.7)', fontSize: 36 }
        },
        series: [
          {
            name: '岗位数量',
            type: 'line',
            data: values,
            smooth: true,
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: { width: 0, color: '#31FFFF' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(49,255,255,0.55)' },
                { offset: 1, color: 'rgba(49,255,255,0.05)' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              color: '#ffffff',
              fontSize: 38,
              fontWeight: 'bold',
              formatter: '{c}'
            }
          },
          {
            name: '岗位数量',
            type: 'bar',
            data: values,
            barWidth: 36,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#31FFFF' },
                { offset: 1, color: 'rgba(49,255,255,0.2)' }
              ]),
              borderRadius: [6, 6, 0, 0]
            }
          }
        ]
      }
      chart.setOption(option)
      window.addEventListener('resize', function(){ chart.resize() })
    },
    // 十五五规划投资分布：中心环形图 + 周围分项，按用户截图样式呈现
    echartsPlan15(){
      var that = this
      var el = document.getElementById('planChart')
      if(!el) return
      var chart = echarts.getInstanceByDom(el)
      if(chart){ echarts.dispose(el) }
      chart = echarts.init(el)
      var total = 8000
      var data = that.plan15Data.map(function(c){
        return {
          name: c.name,
          value: 1,
          realValue: c.value,
          itemNo: c.no,
          itemStyle: { color: c.color }
        }
      })
      var option = {
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.6)',
          borderRadius: 15,
          textStyle: { color: '#ffffff', fontSize: 40 },
          formatter: function(p){
            return '<div style=\'padding:18px 28px;font-size:40px;line-height:54px;\'>' +
              '<b>' + p.data.itemNo + ' · ' + p.name + '</b><br/>' +
              '投资金额：<span style=\'color:#00F0FF;font-weight:700;\'>' + p.data.realValue + '.00 万</span>' +
              '</div>'
          }
        },
        graphic: [
          {
            type: 'text',
            left: 'center',
            top: '40%',
            style: {
              text: '总计投入资金',
              textAlign: 'center',
              fill: 'rgba(255,255,255,.75)',
              fontSize: 44,
              fontWeight: 600
            }
          },
          {
            type: 'text',
            left: 'center',
            top: '50%',
            style: {
              text: String(total),
              textAlign: 'center',
              fill: '#00F0FF',
              fontSize: 96,
              fontWeight: 'bold'
            }
          },
          {
            type: 'text',
            left: 'center',
            top: '62%',
            style: {
              text: '万',
              textAlign: 'center',
              fill: 'rgba(255,255,255,.75)',
              fontSize: 44
            }
          }
        ],
        series: [{
          name: '十五五规划',
          type: 'pie',
          radius: ['55%', '75%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: true,
          itemStyle: {
            borderColor: '#061938',
            borderWidth: 4
          },
          label: {
            show: true,
            position: 'inside',
            formatter: function(p){ return p.data.itemNo },
            color: '#fff',
            fontSize: 40,
            fontWeight: 'bold'
          },
          labelLine: { show: false },
          emphasis: {
            scale: true,
            scaleSize: 10,
            itemStyle: { shadowBlur: 20, shadowColor: 'rgba(0,240,255,0.6)' }
          },
          data: data
        }]
      }
      chart.setOption(option)
      window.addEventListener('resize', function(){ chart.resize() })
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/ganzi';
</style>